import {
  ApplicationConfig,
  inject,
  PLATFORM_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(),
    provideClientHydration(withEventReplay()),
    // Preload the Google Maps "maps" library so google.maps.OverlayView is
    // attached before <map-marker-clusterer> constructs the (OverlayView-based)
    // @googlemaps/markerclusterer — avoids the "reading 'prototype'" race.
    provideAppInitializer(() => {
      const platformId = inject(PLATFORM_ID);
      if (isPlatformBrowser(platformId) && typeof google !== 'undefined' && google.maps?.importLibrary) {
        return (google.maps.importLibrary('maps') as Promise<unknown>).catch(() => undefined);
      }
      return;
    }),
  ],
};
